<template>
    <div>
        <v-tabs id="system-configuration-tabs" v-model="currentTab" fixed-tabs centered hide-slider>
            <v-tab v-for="tab in tabs" :key="tab.name" :href="tab.href" :ripple="false">
                {{ tab.name }}
            </v-tab>
        </v-tabs>
        <v-divider class="ma-0" />
    </div>
</template>
<script>
    export default {
        props: {
            currentTab: {
                type: String,
                default: '',
            },
        },

        data: () => ({
            tabs: [
                {
                    name: 'Institutions',
                    href: 'ManageInstitutions',
                },
                {
                    name: 'Grade Levels',
                    href: 'ManageGradeLevels',
                },
                {
                    name: 'Resource Types',
                    href: 'ManageResourceTypes',
                },
                {
                    name: 'Programs',
                    href: 'ManagePrograms',
                },
                {
                    name: 'Tags',
                    href: 'ManageTags',
                },
                {
                    name: 'Blocked Domains',
                    href: 'ManageBlockedEmailDomains'
                }],
        }),
    };
</script>
<style>
    #system-configuration-tabs .v-tabs__item.v-tabs__item--active {
        color: #D2202F;
        font-weight: bold;
    }
</style>